/* global axios */
import ApiClient from '../ApiClient';

class AidexacxDocument extends ApiClient {
  constructor() {
    super('aidexacx/documents', { accountScoped: true });
  }

  get({ page = 1, searchKey, assistantId } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        searchKey,
        assistant_id: assistantId,
      },
    });
  }

  retry(id) {
    return axios.post(`${this.url}/${id}/retry`);
  }
}

export default new AidexacxDocument();
